import React, { useEffect, useState } from "react";

import Table from "../../../../../core/pagination/datatable";

import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import SetACreditRemind from "./SetACreditRemind";

import { Link, useParams } from "react-router-dom";

import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import Swal from "sweetalert2";
import {
  Select as TagSelector,
  Spin,
  Empty,
  Input,
  DatePicker,
  Drawer,
  Button,
  Card,
  Divider,
} from "antd";

import { CloseOutlined } from "@ant-design/icons";
import { EditOutlined } from "@ant-design/icons";
const CreditNoteInfo = () => {
  //   const [activeTab, setActiveTab] = useState("estimate");
  //    const dataSource = useSelector((state) => state.rootReducer.CRMCustomers);

  //  const renderTooltip = (props) => (
  //     <Tooltip id="pdf-tooltip" {...props}>
  //       Pdf
  //     </Tooltip>
  //   );
  const columns1 = [
    {
      title: "Description",
      dataIndex: "company",
      sorter: (a, b) => a.company?.length - b.company?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },

    {
      title: "Date",
      dataIndex: "primaryContact",
      sorter: (a, b) => a.primaryContact?.length - b.primaryContact?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "Remind",
      dataIndex: "primaryEmail",
      sorter: (a, b) => a.primaryEmail?.length - b.primaryEmail?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
    {
      title: "is notified",
      dataIndex: "phone",
      sorter: (a, b) => a.phone?.length - b.phone?.length,
      render: (text) =>
        text?.length > 15 ? `${text.substring(0, 15)}...` : text,
    },
  ];

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;

  const { id } = useParams();

  //get credit note integration

  const [creditNoteDetails, setCreditNoteDetails] = useState({});
  const [loading, setLoading] = useState(false);

  console.log(creditNoteDetails, loading, "creditNoteDetails");

  const getCreditNoteById = async (id) => {
    try {
      setLoading(true);
      const response = await fetch(
        `${BASE_CRM_URL}creditnotes/GetCreditNote/${id}`
      );

      const data = await response.json();

      setCreditNoteDetails(data.Data);
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getCreditNoteById(id);
  }, []);

  // reminders code for proposal

  const [reminders, setReminders] = useState([]);
  const [remindersLoading, setRemindersLoading] = useState(false);

  const [addReminderLoading, setAddReminderLoading] = useState(false);
  const [updateReminderLoading, setUpdateReminderLoading] = useState(false);

  const [editingReminderId, setEditingReminderId] = useState(null);

  const [reminderData, setReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [editReminderData, setEditReminderData] = useState({
    description: "",
    date: null,
    staff: userId,
  });

  const [staffList, setStaffList] = useState([]);
  const [staffLoading, setStaffLoading] = useState(false);

  const [reminderDrawerOpen, setReminderDrawerOpen] = useState(false);

  const fetchReminders = async () => {
    try {
      setRemindersLoading(true);

      const response = await fetch(
        `${BASE_CRM_URL}reminder/GetReminders?rel_id=${id}&rel_type=CrediNote&staffid=0`
      );

      const data = await response.json();

      if (data.Status) {
        setReminders(data.ResultData || []);
      } else {
        setReminders([]);
      }
    } catch (error) {
      console.error(error);
      setReminders([]);
    } finally {
      setRemindersLoading(false);
    }
  };

  const fetchStaff = async () => {
    try {
      setStaffLoading(true);

      const response = await fetch(`${BASE_CRM_URL}staff/GetStaffDropdown`);
      const data = await response.json();

      if (data.ResultData) {
        setStaffList(data.ResultData);
      } else {
        setStaffList([]);
      }
    } catch (error) {
      console.error("Error fetching staff:", error);
      setStaffList([]);
    } finally {
      setStaffLoading(false);
    }
  };
  const handleAddReminder = async () => {
    if (!reminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    if (!reminderData.date) {
      Swal.fire({
        icon: "warning",
        title: "Reminder Date Required",
        text: "Please select reminder date.",
      });
      return;
    }

    try {
      setAddReminderLoading(true);
      const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
      const userId = userDetails?.staffid;
      const response = await fetch(`${BASE_CRM_URL}reminder/AddReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          description: reminderData.description,
          date: dayjs(reminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          rel_id: id,
          rel_type: "CreditNote",
          staff: reminderData.staff,
          creator: userId,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setReminderData({
          description: "",
          date: null,
          staff: userId,
        });

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setAddReminderLoading(false);
    }
  };

  const handleEditReminder = (reminder) => {
    setEditingReminderId(reminder.id);

    setEditReminderData({
      description: reminder.description,
      date: dayjs(reminder.date),
      staff: reminder.staff,
    });
  };

  const handleCancelReminderEdit = () => {
    setEditingReminderId(null);

    setEditReminderData({
      description: "",
      date: null,
      staff: userId,
    });
  };

  const handleUpdateReminder = async () => {
    if (!editReminderData.description.trim()) {
      Swal.fire({
        icon: "warning",
        title: "Description Required",
        text: "Please enter reminder description.",
      });
      return;
    }

    try {
      setUpdateReminderLoading(true);

      const response = await fetch(`${BASE_CRM_URL}reminder/UpdateReminder`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id: editingReminderId,
          description: editReminderData.description,
          date: dayjs(editReminderData.date).format("YYYY-MM-DD HH:mm:ss"),
          staff: editReminderData.staff,
        }),
      });

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Updated",
          text: data.Message,
          timer: 1500,
          showConfirmButton: false,
        });

        setEditingReminderId(null);

        fetchReminders();
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: data.Message,
        });
      }
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong.",
      });
    } finally {
      setUpdateReminderLoading(false);
    }
  };

  useEffect(() => {
    fetchReminders();
    fetchStaff();
  }, []);

  const handleCloseReminderDrawer = () => {
    setReminderDrawerOpen(false);
    setEditingReminderId(null);

    setReminderData({
      description: "",
      date: null,
      staff: null,
    });

    setEditReminderData({
      description: "",
      date: null,
      staff: null,
    });
  };
  return (
    <>
      <div className="page-wrapper">
        <div className="content pt-2">
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb d-flex justify-content-between w-100">
              <div className="d-flex align-items-center">
                <li className="breadcrumb-item">
                  <Link to="/crm/Dashboard">
                    <i className="fas fa-home fa-lg" />
                  </Link>
                </li>
                <h4 className="breadcrumb-item mb-0" aria-current="page">
                  Credit Note Info
                </h4>
              </div>
              <ul
                className="nav nav-tabs nav-tabs-bottom "
                id="myTab"
                role="tablist"
              >
                {/* <li className="nav-item" role="presentation">
                  <Link
                    className="nav-link active"
                    id="estimate-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#estimate-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="estimate-tab-pane"
                    aria-selected="true"
                  >
                    Credit Note
                  </Link>
                </li> */}
                {/* <li className="nav-item" role="presentation">
                  <Link
                    className="nav-link"
                    id="tasks-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#tasks-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="tasks-tab-pane"
                    aria-selected="false"
                  >
                    Invoices Credited
                  </Link>
                </li> */}
                {/* <li className="nav-item" role="presentation">
                  <Link
                    className="nav-link"
                    id="activity-tab"
                    data-bs-toggle="tab"
                    data-bs-target="#activity-tab-pane"
                    type="button"
                    role="tab"
                    aria-controls="activity-tab-pane"
                    aria-selected="false"
                  >
                    Refunds
                  </Link>
                </li> */}
                <li className="nav-item d-none" role="presentation">
                  <Link
                    to="#"
                    className="nav-link"
                    onClick={(e) => {
                      e.preventDefault();
                      setReminderDrawerOpen(true);
                    }}
                  >
                    Reminders
                  </Link>
                </li>
              </ul>
              <div className="page-btn d-flex justify-content-between align-items-center flex-wrap ">
                <span
                  className="badge px-3 py-2 g-2 me-2"
                  style={{ backgroundColor: "#90EE90", color: "#000000" }}
                >
                  {creditNoteDetails?.status_name || "-"}
                </span>

                <div className="d-flex align-items-center">
                  <Link className="btn btn-light btn-sm me-2">
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="PDF Icon"
                    />
                  </Link>

                  {/* <Link
                    className="btn btn-soft-secondary btn-sm me-2"
                    style={{ color: "#fff" }}
                  >
                    Apply To Invoice
                  </Link>
                  <Link className="btn btn-soft-secondary btn-sm me-2">
                    More <i className="fas fa-chevron-down"></i>
                  </Link> */}
                  <Link to="/crm/creditnotes" className="btn btn-dark btn-sm">
                    <i className="ti ti-arrow-left"></i>
                  </Link>
                </div>
              </div>
            </ol>
          </nav>

          <div className="container-fluid">
            <div className="card shadow">
              <div className="card-body pb-1 ">
                <div className="row align-items-center">
                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <span className="fw-bold me-2">Credit No:</span>
                      <span className="fw-bold text-danger">
                        {creditNoteDetails?.credit_note_number}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-regular fa-calendar me-2"></i>
                      <span className="fw-bold me-2">Issued On:</span>
                      <span className="fw-bold">
                        {dayjs(creditNoteDetails?.datecreated).format(
                          "DD-MM-YYYY"
                        )}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 border-end text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-regular fa-clock  me-2"></i>
                      <span className="fw-bold me-2">CreatedBy:</span>
                      <span className="fw-bold text-info">
                        {creditNoteDetails?.added_by || "-"}
                      </span>
                    </div>
                  </div>

                  <div className="col-md-3 col-sm-6 mb-2 text-center">
                    <div className="d-inline-flex align-items-center">
                      <i className="fa-solid fa-indian-rupee-sign me-2"></i>
                      <span className="fw-bold me-2">Total:</span>
                      <span className="fw-bold text-success">
                        ₹ {creditNoteDetails?.total}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="card shadow">
              <div className="card-body pt-0">
                <div className="tab-content" id="myTabContent">
                  <div
                    className="tab-pane fade show active"
                    id="estimate-tab-pane"
                    role="tabpanel"
                    aria-labelledby="estimate-tab"
                  >
                    <div className="row mt-3 ">
                      <div className="col-md-4">
                        <h6>
                          {" "}
                          <i className="fa-solid fa-building me-2"></i>
                          Perennial Code IT Consultants Pvt. Ltd
                        </h6>
                        <p className="mb-1">
                          <i className="fa-solid fa-map-location-dot  me-2"></i>
                          Vidya Nagar, Hyderabad Telangana ,INDIA 500044
                        </p>

                        <p className="mb-1">
                          <i className="fa-solid fa-file-invoice  me-2"></i>
                          GSTIN: <strong>36AAHCP8044R1ZM</strong>
                        </p>
                        <p>
                          <i className="fa-solid fa-phone-volume  me-2"></i>Off:
                          +91 4048513363, +91 8297230010 (M)
                        </p>
                      </div>
                      <div className="col-md-4 d-flex justify-content-center align-items-end">
                        <div className="text-start">
                          <p className="mb-0">
                            <i className="fa-solid fa-user-check me-2"></i>
                            <strong>CreatedBy:</strong>{" "}
                            {/* {proposalDetails?.Proposal.AddedByName} */}
                            {creditNoteDetails?.added_by || "-"}
                          </p>
                          <p>
                            <strong>
                              {" "}
                              <i className="fa-solid fa-calendar me-2"></i>
                              Credit Note Date
                            </strong>
                            :
                            {dayjs(creditNoteDetails?.datecreated).format(
                              "DD-MM-YYYY"
                            )}
                          </p>
                        </div>
                      </div>
                      <div className="col-md-4 text-end">
                        <h6>Bill To:</h6>
                        <p className="mb-1">
                          <i className="fa-solid fa-building me-2"></i>
                          {creditNoteDetails?.customer_name}
                        </p>
                        <p className="mb-1">
                          <i className="fa-solid fa-map-location-dot  me-2"></i>
                          {creditNoteDetails?.billing_street || "-"}
                          {","}
                          {creditNoteDetails?.billing_city || "-"}
                          {","} {creditNoteDetails?.billing_state || "-"}
                          {","}
                          {creditNoteDetails?.billing_zip || "-"}
                        </p>

                        <p>
                          <i className="fa-solid fa-file-invoice  me-2"></i>
                          IN: <strong>36AVKPG0403A1ZE</strong>
                        </p>
                      </div>
                    </div>

                    <hr />

                    <div className="table-responsive">
                      <table className="table table-bordered">
                        <thead className="table-striped">
                          <tr>
                            <th>#</th>
                            <th>Item</th>
                            <th>Qty</th>
                            <th>Rate</th>
                            <th>Tax</th>
                            <th>Amount</th>
                          </tr>
                        </thead>

                        <tbody>
                          {creditNoteDetails?.items?.length > 0 ? (
                            creditNoteDetails.items.map((item, index) => (
                              <tr key={item.id || index}>
                                <td>{index + 1}</td>
                                <td
                                  style={{
                                    whiteSpace: "normal",
                                    wordBreak: "break-word",
                                    maxWidth: "1050px",
                                  }}
                                >
                                  {item.description || "-"}
                                </td>
                                <td>{item.qty || "-"}</td>
                                <td>{item.rate || "-"}</td>
                                <td>
                                  {item?.taxes?.length
                                    ? item.taxes.map((tax, index) => (
                                        <div key={index}>
                                          {tax.taxname} ({tax.taxrate}%)
                                        </div>
                                      ))
                                    : "-"}
                                </td>
                                <td>{creditNoteDetails?.total || "-"}</td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="6" className="text-center">
                                No Items Found
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </div>

                    <div className="mt-3 d-flex flex-column align-items-end">
                      <p className="mb-1">
                        Sub Total:<span className="ms-5"></span>
                        {creditNoteDetails?.subtotal || "-"}
                      </p>
                      <hr className="my-2 w-50" />
                      <p className="mb-1">
                        Total_Tax:<span className="ms-5"></span>
                        {creditNoteDetails?.total_tax || "-"}
                      </p>
                      <hr className="my-2 w-50" />
                      <p className="mb-1">
                        Total :<span className="ms-5"></span>{" "}
                        {creditNoteDetails?.total || "-"}
                      </p>
                      {/* <hr className="my-2 w-50" /> */}
                      {/* <h5 className="fw-bold">
                        Credit Remaining:<span className="ms-5"></span>{" "}
                        {creditNoteDetails?.remaining || "-"}
                      </h5> */}
                    </div>
                    <div className="row">
                      <div className="col-12 text-start">
                        <p>
                          <strong>Note:</strong>{" "}
                          {creditNoteDetails?.adminnote || "-"}
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* Other Tab Content (Tasks, Activity, etc.) */}
                  <div
                    className="tab-pane fade"
                    id="tasks-tab-pane"
                    role="tabpanel"
                    aria-labelledby="tasks-tab"
                  >
                    <div className="container mt-3">
                      <div
                        className="alert alert-secondary text-start p-4 mb-3"
                        role="alert"
                      >
                        <h5 className="alert-heading">
                          Credited Invoices Not Found
                        </h5>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="activity-tab-pane"
                    role="tabpanel"
                    aria-labelledby="activity-tab"
                  >
                    <div className="container mt-3">
                      <div
                        className="alert alert-secondary text-start p-4 mb-3"
                        role="alert"
                      >
                        <h5 className="alert-heading">No Refunds Found</h5>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="reminders-tab-pane"
                    role="tabpanel"
                    aria-labelledby="reminders-tab"
                  >
                    <div className="card table-list-card">
                      <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
                        <div className="search-set"></div>
                        <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
                          {/* <div className="dropdown me-2">
                <Link
                  to="#"
                  className="dropdown-toggle btn btn-white btn-md d-inline-flex align-items-center"
                  data-bs-toggle="dropdown"
                >
                  Location
                </Link>
                <ul className="dropdown-menu  dropdown-menu-end p-3">
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Hyderabad
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Bangalore
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      NewYork
                    </Link>
                  </li>
                  <li>
                    <Link to="#" className="dropdown-item rounded-1">
                      Germany
                    </Link>
                  </li>
                </ul>
              </div> */}
                          <div className="d-flex justify-content-end my-0">
                            {/* Right section with buttons */}
                            <div className="d-flex justify-content-around mb-2">
                              <div className="me-3 ">
                                <Link
                                  to="edit-sales.html"
                                  className="btn btn-primary text-white"
                                  data-bs-toggle="offcanvas"
                                  data-bs-target="#offcanvasSetACreditReminder"
                                  aria-controls="#offcanvasSetACreditReminder"
                                >
                                  <i className="fa fa-bell me-1"></i>
                                  Set A CreditNote Reminder
                                </Link>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="table-responsive">
                          <Table columns={columns1} />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="terms-tab-pane"
                    role="tabpanel"
                    aria-labelledby="terms-tab"
                  >
                    <div className="container mt-3">
                      <div
                        className="alert alert-secondary text-start p-4 mb-3"
                        role="alert"
                      >
                        <h5 className="alert-heading">
                          No Tracked Emails Sent
                        </h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Drawer
            title="Reminders"
            open={reminderDrawerOpen}
            onClose={handleCloseReminderDrawer}
            width={550}
            destroyOnClose
            maskClosable={true}
            closable={false}
            extra={
              <Button
                type="text"
                icon={<CloseOutlined />}
                onClick={() => setReminderDrawerOpen(false)}
              />
            }
          >
            {/* Add / Edit Form */}

            {editingReminderId === null ? (
              <>
                <Input.TextArea
                  rows={3}
                  placeholder="Reminder description"
                  value={reminderData.description}
                  onChange={(e) =>
                    setReminderData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                />

                <div className="row mt-3">
                  <div className="col-md-6">
                    <DatePicker
                      showTime
                      className="w-100"
                      value={reminderData.date}
                      onChange={(value) =>
                        setReminderData((prev) => ({
                          ...prev,
                          date: value,
                        }))
                      }
                    />
                  </div>

                  <div className="col-md-6">
                    <TagSelector
                      className="w-100"
                      style={{ height: 38 }}
                      placeholder="Select Staff"
                      loading={staffLoading}
                      value={reminderData.staff}
                      onChange={(value) =>
                        setReminderData((prev) => ({
                          ...prev,
                          staff: value,
                        }))
                      }
                      options={staffList.map((staff) => ({
                        value: staff.staffid,
                        label: `${staff.firstname} ${staff.lastname}`,
                      }))}
                    />
                  </div>
                </div>

                <div className="text-end mt-3">
                  <Button
                    type="primary"
                    loading={addReminderLoading}
                    onClick={handleAddReminder}
                  >
                    Add
                  </Button>
                </div>
              </>
            ) : (
              <>
                {/* Edit Form */}
                <Input.TextArea
                  rows={3}
                  value={editReminderData.description}
                  onChange={(e) =>
                    setEditReminderData((prev) => ({
                      ...prev,
                      description: e.target.value,
                    }))
                  }
                />
                <div className="row mt-3">
                  <div className="col-md-6">
                    <DatePicker
                      showTime
                      className="w-100 mt-3"
                      value={editReminderData.date}
                      onChange={(value) =>
                        setEditReminderData((prev) => ({
                          ...prev,
                          date: value,
                        }))
                      }
                    />
                  </div>
                  <div className="col-md-6">
                    <TagSelector
                      className="w-100 mt-3"
                      style={{ height: 38 }}
                      value={editReminderData.staff}
                      onChange={(value) =>
                        setEditReminderData((prev) => ({
                          ...prev,
                          staff: value,
                        }))
                      }
                      options={staffList.map((staff) => ({
                        value: staff.staffid,
                        label: `${staff.firstname} ${staff.lastname}`,
                      }))}
                    />
                  </div>
                </div>
                <div className="text-end mt-3">
                  <Button className="me-2" onClick={handleCancelReminderEdit}>
                    Cancel
                  </Button>

                  <Button
                    type="primary"
                    loading={updateReminderLoading}
                    onClick={handleUpdateReminder}
                  >
                    Update
                  </Button>
                </div>
              </>
            )}

            <Divider>Reminder List</Divider>

            {remindersLoading ? (
              <div className="text-center py-4">
                <Spin />
              </div>
            ) : reminders.length > 0 ? (
              reminders.map((reminder) => (
                <Card key={reminder.id} size="small" className="mb-3 shadow">
                  <div className="d-flex justify-content-between">
                    <div>
                      <div>{reminder.description}</div>

                      <div className="d-flex align-items-center gap-3 text-muted mt-2">
                        <small>
                          <i className="fa fa-user me-2"></i>
                          {reminder.firstname} {reminder.lastname}
                        </small>

                        <small>
                          <i className="fa fa-calendar me-2"></i>
                          {dayjs(reminder.date).format("DD-MM-YYYY hh:mm A")}
                        </small>
                      </div>
                    </div>

                    <Button
                      type="text"
                      icon={<EditOutlined />}
                      onClick={() => handleEditReminder(reminder)}
                    />
                  </div>
                </Card>
              ))
            ) : (
              <Empty description="No reminders found" />
            )}
          </Drawer>

          <SetACreditRemind />
        </div>
      </div>
    </>
  );
};

export default CreditNoteInfo;
